<div style="background-color: #F5F7F8; height: 100vh; padding-top: 40px;">
    <h1 style="font-weight: bold; text-align: center">{{  this.pageDetails().title }}</h1>
    <p style=" text-align: center;">Въведете имейла си, за да ви изпратим имейл с <br> инструкции за възстановяване на паролата.</p>
    <img style="width: 22px; height: 22px; position: absolute; top: 65px; left: 20px;" (click)="this.back()" src="/assets/images/shared/back.svg">
    <form [formGroup]="this.forgottenPasswordInfo">
        <input type="text" class="form-control" formControlName="email" [placeholder]="this.pageDetails().email" aria-label="Username" aria-describedby="basic-addon1">
        <div style="position: fixed; bottom: 40px; text-align: center; width: 90%; margin: auto; left: 5%;">
            <button  [disabled]="!this.forgottenPasswordInfo.touched" type="button" class="btn btn-primary" style="width: 100%; margin: auto;" (click)="this.send()"> {{ this.pageDetails().button }} </button>
        </div>
    </form>
</div>
<router-outlet></router-outlet>
